import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    list: [],
    editingProject: null
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }) {
      api.getList().then(({ data }) => {
        commit('setList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    remove(context, data) {
      return api.remove(data);
    },
    close(context, data) {
      return api.close(data);
    },
    getConfig() {
      return api.getConfig();
    },
    updateConfig(context, data) {
      return api.updateConfig(data);
    },
    setUnlock(context, data) {
      return api.setUnlock(data);
    },
    setLock(context, data) {
      return api.setLock(data);
    },
    setConsider(context, data) {
      return api.setConsider(data);
    },
    setOwnerChange(context, data) {
      return api.setOwnerChange(data);
    }
  }
};

appStore.registerModule('league', store);
